import { render, staticRenderFns } from "./CourseViewAddStudent.vue?vue&type=template&id=eac537ce&"
import script from "./CourseViewAddStudent.vue?vue&type=script&lang=js&"
export * from "./CourseViewAddStudent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports